import React from "react";
import { useParams } from "react-router-dom";
import blogs from '../Data/blogs';
export default function BlogDetail() {
  const { slug } = useParams();

  const blog = blogs.find((b) => b.slug === slug);

  if (!blog) {
    return <h2 style={{ padding: "120px" }}>Blog not found</h2>;
  }

  return (
    <div style={{ padding: "120px 20px", maxWidth: "900px", margin: "auto" }}>
      <h1>{blog.title}</h1>

      <p style={{ color: "var(--text-muted)" }}>{blog.date}</p>

      <p style={{ marginTop: "30px", lineHeight: "1.7" }}>{blog.content}</p>
    </div>
  );
}